<template>
  <div>
    <div class="docWrap" style="width: 100%; height: 500px">
      <!-- 预览文件的地方（用于渲染） -->
      <div ref="file" style="width: 100%; height: 100%; overflow-y: auto;"></div>
    </div>
  </div>
</template>
  <script>
import { fileDownload } from "@/api/user";
// let docx = require("docx-preview");
// import docxPreview from 'docx-preview'
// import axios from "axios";
window.JSZip = require("jszip");
const docxP = require("docx-preview");
export default {
  name: "previewDoc",
  props: {
    pdfFile: {
      type: String,
      default: "",
    },
    funcs: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
      pdfFile: {
          handler(file) {
            let _this = this
            if (file) {
                _this.getDocUrl(file)
            }
          },
          deep: true,
          immediate: true
      }
  },
  methods: {
    async getDocUrl(file) {
      let res = await fileDownload(file.url.split("=")[1]);
        docxP.renderAsync(res.data, this.$refs.file); // 渲染到页面
      // axios({
      //   method: "get",
      //   responseType: "blob", // 因为是流文件，所以要指定blob类型
      //   url: "http://ashuai.work:10000/getDoc", // 自己的服务器，提供的一个word下载文件接口
      // }).then((res) => {
      //   console.log(res); // 后端返回的是流文件
      //   docxP.renderAsync(res.data, this.$refs.file); // 渲染到页面
      // });

      // this.$nextTick(() => {
      //   docxP.renderAsync('http://ashuai.work:10000/getDoc', this.$refs.file).then((res) => {
      //     console.log(res, "res");
      //   });
      // });
    },
  }, // 挂载一些方法
};
</script>
  
  <style lang="scss" scoped></style>